import React from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import type { Faq } from '../../types/content';
interface FaqItemProps {
  faq: Faq;
  open: boolean;
  onToggle: () => void;
}
export function FaqItem({
  faq,
  open,
  onToggle
}: FaqItemProps) {
  const reduceMotion = useReducedMotion();
  const buttonId = `faq-btn-${faq.id}`;
  const panelId = `faq-panel-${faq.id}`;
  return <div className="border-b border-line" data-id="element-168" data-mp="2j516r7bqk2hp">
      <h3 data-id="element-169" data-mp="2o3uj2wfadnga">
        <button id={buttonId} type="button" aria-expanded={open} aria-controls={panelId} onClick={onToggle} className="flex min-h-[64px] w-full items-center justify-between gap-6 py-4 text-left font-display text-[22px] text-ink md:text-2xl" data-id="element-170" data-mp="2o3krx5ii9a90">
          {faq.question}
          <PlusIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-bronze-deep transition-transform duration-200 ease-out ${open ? 'rotate-45' : ''}`} data-id="element-171" data-mp="yn383mrh941x" />
        </button>
      </h3>
      <AnimatePresence initial={false} data-id="element-172" data-mp="2nicbsvtm16i6">
        {open && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={reduceMotion ? false : {
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-173" data-mp="2iipxej21pk7s">
            <p className="max-w-2xl pb-6 text-[16px] leading-relaxed text-ink-muted" data-id="element-174" data-mp="31eg24e1d4upd">{faq.answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}